const data = [
    {
        name: "Monika Dhakad",
        ImageUrl: "/Team/Advisors/Monika_Dhakar.jpg",
        position: ["Governor", "Alumni Coordinator"],
        facebookLink: "https://www.facebook.com/share/1784QbgJkw/",
        linkedinLink: "https://www.linkedin.com/in/monika-dhakad-558811330?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        InstagramLink: "https://www.instagram.com/_monika_dhakkad__/"
    },
    {
        name: "Deepak Jangir",
        ImageUrl: "/Team/Advisors/Deepak_Jangir.jpg",
        position: [ "Governor", "Alumni Coordinator", "Finance Advisor"],
        facebookLink: "https://www.facebook.com/share/169S9Sboue/",
        linkedinLink: "https://www.linkedin.com/in/deepak-jangir-bba615315",
        InstagramLink: "https://www.instagram.com/__deepakjangir/"
    }
]

export default data;